import { Menu } from "lucide-react";

import { Button } from "components/ui/button";
import { useSidebar } from "components/ui/sidebar";

// Below the mobile breakpoint the primitive renders a rail as a closed sheet with
// no trigger of its own, so this labelled bar above the content opens it. Renders
// nothing on wider viewports, where the docked rail carries its own trigger.
export function SidebarMobileTriggerBar({ label = "Navigation" }) {
  const { isMobile, toggleSidebar } = useSidebar();

  if (!isMobile) {
    return null;
  }

  return (
    <div className="tw:flex tw:shrink-0 tw:items-center tw:border-b tw:border-[var(--color-border)] tw:px-4 tw:py-2">
      <Button variant="ghost" onClick={toggleSidebar}>
        <Menu data-icon="inline-start" />
        {label}
      </Button>
    </div>
  );
}
